import dayjs from 'dayjs';

export const isEmptyObj = (obj: object): boolean => {
    return obj == null || Object.keys(obj).length === 0;
};

export const isValidEmail = (userInput: string | null): boolean => {
    //Function to check validation of email address inserted by the user.
    if (!userInput) {
        return;
    }

    const validMailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    return validMailRegex.test(userInput);
};

export const isValidPhoneNumber = (userInput: string | null): boolean => {
    if (!userInput) {
        return false;
    }

    // General international phone number validation
    const validPhoneRegex = /^\+?[0-9]\d{1,14}$/;

    // Regex for Israeli phone numbers (both landline and mobile)
    // Handles formats like: 0501234567, +972501234567, 0723123456
    const israelPhoneRegex = /^(?:\+972|972|0)([23489]|5\d|7[2346789])\d{7}$/;

    if (!validPhoneRegex.test(userInput)) {
        return false;
    }

    const isIsraeliNumber = israelPhoneRegex.test(userInput);

    if (!isIsraeliNumber) {
        console.log('Note: The phone number is not Israeli.');
    }

    return true;
};

export const formatRelativeDate = (date: Date | string) => {
    const monthsHe = ['ינו׳', 'פבר׳', 'מרץ', 'אפר׳', 'מאי', 'יונ׳', 'יול׳', 'אוג׳', 'ספט׳', 'אוק׳', 'נוב׳', 'דצמ׳'];
    const d = dayjs(date);
    const now = dayjs();

    if (d.isSame(now, 'day')) {
        // היום: רק שעה
        return d.format('HH:mm');
    } else if (d.isSame(now, 'month')) {
        // אותו חודש: יום וחודש
        return `${d.date()} ב${monthsHe[d.month()]}`;
    } else if (d.isSame(now, 'year')) {
        // אותה שנה: יום, חודש
        return `${d.date()} ב${monthsHe[d.month()]}`;
    } else {
        // שנה אחרת: יום, חודש, שנה
        return `${d.date()} ב${monthsHe[d.month()]} ${d.year()}`;
    }
};
